
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research-papers",
      function () {
        return require("private-next-pages/research-papers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research-papers"])
      });
    }
  